import { Routes, Route, Navigate } from 'react-router-dom';
import { useCustomerAuth } from '@/hooks/useAuth';
import { ProtectedRoute } from '@connor-music/shared';
import { CustomerLayout } from '@/components/CustomerLayout';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Upload from '@/pages/Upload';
import UploadHistory from '@/pages/UploadHistory';
import Security from '@/pages/Security';

function App() {
  const { isAuthenticated, isLoading } = useCustomerAuth();

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />

      {/* Protected routes */}
      <Route
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} isLoading={isLoading}>
            <CustomerLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="projects/:projectId/upload" element={<Upload />} />
        <Route path="uploads" element={<UploadHistory />} />
        <Route path="security" element={<Security />} />
      </Route>

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
